document.addEventListener('DOMContentLoaded', () => {
  const buttons = document.querySelectorAll('button[datapopup]');
  
  buttons.forEach(button => {
    const popupId = button.getAttribute('datapopup');
    const dialog = document.querySelector(`dialog[datapopup="${popupId}"]`);
    
    if (!dialog) return;

    button.addEventListener('click', () => {
      dialog.showModal();
    });

    dialog.addEventListener('click', (e) => {
      if (e.target === dialog) dialog.close();
    });
  });
});